import {AtUri} from '@atproto/syntax'

import {ERIS_IDENTITY, getOriginalProfileHandle} from '#/lib/eris-identity'
import {isInvalidHandle} from '#/lib/strings/handles'
import {type app} from '#/lexicons'

const PROFILE_PAGE_SEGMENTS = new Set([
  'followers',
  'follows',
  'known-followers',
  'search',
])

export function makeProfileLink(
  info: {
    did: string
    handle: string
  },
  ...segments: string[]
) {
  const isProfilePage =
    segments.length === 0 || PROFILE_PAGE_SEGMENTS.has(segments[0])
  const originalHandle = getOriginalProfileHandle(info)
  let handleSegment = isProfilePage ? ERIS_IDENTITY.handle : info.did
  if (!isProfilePage && originalHandle && !isInvalidHandle(originalHandle)) {
    handleSegment = originalHandle
  }
  return [`/profile`, handleSegment, ...segments].join('/')
}

export function makeCustomFeedLink(
  did: string,
  rkey: string,
  segment?: string,
  feedCacheKey?: 'discover' | 'explore',
) {
  return (
    [`/profile`, did, 'feed', rkey, ...(segment ? [segment] : [])].join('/') +
    (feedCacheKey ? `?feedCacheKey=${encodeURIComponent(feedCacheKey)}` : '')
  )
}

export function makeListLink(did: string, rkey: string, ...segments: string[]) {
  return [`/profile`, did, 'lists', rkey, ...segments].join('/')
}

export function makeTagLink(did: string) {
  return `/search?q=${encodeURIComponent(did)}`
}

export function makeSearchLink(props: {query: string; from?: 'me' | string}) {
  return `/search?q=${encodeURIComponent(
    props.query + (props.from ? ` from:${props.from}` : ''),
  )}`
}

export function makeStarterPackLink(
  starterPackOrName:
    | app.bsky.graph.defs.StarterPackViewBasic
    | app.bsky.graph.defs.StarterPackView
    | string,
  rkey?: string,
) {
  if (typeof starterPackOrName === 'string') {
    return `https://bsky.app/start/${starterPackOrName}/${rkey}`
  } else {
    const uriRkey = new AtUri(starterPackOrName.uri).rkey
    return `https://bsky.app/start/${getOriginalProfileHandle(starterPackOrName.creator)}/${uriRkey}`
  }
}
